import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { catchError, Observable, throwError } from 'rxjs';
import { ItineraryGenerateTemplateInterface } from '@interfaces/itinerary-generate-template.interface';

@Injectable({
  providedIn: 'root',
})
export class SendItirenaryService {
  constructor(private readonly httpClient: HttpClient) {}

  sendItineraryNotification(serviceRequestId: string): Observable<any> {
    return this.httpClient.get<string>(`${environment.apiUrl}/ServiceRequest/SendSRReadyNotification/${serviceRequestId}`)
    .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getItineraryNotificationMemberList(serviceRequestId: string): Observable<any> {
    return this.httpClient.get<string>(`${environment.apiUrl}/ServiceRequest/GetSRReadyNotificationRecipients/${serviceRequestId}`)
    .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  dismissItineraryNotification(notificationId: string): Observable<any> {
    return this.httpClient.get<string>(`${environment.apiHost}/NotificationDashboard/DismissCustomerNotification/${notificationId}`)
    .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  itineraryGenerateTemplate(serviceRequestId: string): Observable<ItineraryGenerateTemplateInterface> {
    return this.httpClient.get<ItineraryGenerateTemplateInterface>(`${environment.apiUrl}/ItineraryTemplate/GenerateTemplate/${serviceRequestId}`)
    .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  itinerarySaveTemplate(templateId: string, generatedText: string): Observable<unknown> {
    const params = { templateId, generatedText };
    return this.httpClient.post(`${environment.apiUrl}/ItineraryTemplate/SaveTemplate/`, params);
  }
}
